import React from "react";
import { PRODUCTS } from "../../../data";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Products() {
  const joinWaitlist = (name) => {
    const list = JSON.parse(localStorage.getItem("hts_waitlist") || "[]");
    list.push({ product: name, ts: new Date().toISOString() });
    localStorage.setItem("hts_waitlist", JSON.stringify(list));
    toast.success("Sei in lista d'attesa. Ti scriviamo appena si apre.");
  };

  return (
    <section id="prodotti" className="py-16 px-4">
      <div className="mx-auto max-w-[1000px] lg:max-w-[1440px] lg:px-8">
        <div className="text-center mb-10">
          <div className="v-label">{PRODUCTS.label}</div>
          <h2 className="v-serif v-ink mt-3" style={{ fontSize: "clamp(2rem, 5vw, 3rem)", fontStyle: "italic", fontWeight: 400 }}>{PRODUCTS.title}</h2>
          <p className="v-sans mt-3" style={{ color: "#98959F", fontSize: "1rem" }}>{PRODUCTS.subtitle}</p>
        </div>

        <div className="mx-auto grid gap-5 max-w-[620px] lg:max-w-[1120px]">
          {PRODUCTS.items.map((p, i) => (
            <div key={i} className="v-card overflow-hidden flex flex-col lg:flex-row">
              {/* header con copertina reale */}
              <div className="relative w-full lg:w-[58%] lg:shrink-0" style={{ aspectRatio: "16/9", background: "#0B0B0E" }}>
                <img src={p.cover} alt={p.name} loading="lazy" className="w-full h-full object-cover" />
                <span className="v-badge" style={{ position: "absolute", top: 16, left: 16 }}>{p.badge}</span>

              </div>

              <div className="p-7 flex flex-col flex-1 lg:p-10 lg:justify-center">
                <h3 className="v-serif v-ink" style={{ fontSize: "1.7rem", fontStyle: "italic", fontWeight: 400 }}>{p.type}</h3>
                <p className="v-sans mt-3 flex-1" style={{ fontSize: "1rem", color: "#B4B1BA" }}>{p.copy}</p>
                <div data-testid="product-availability" className="v-sans mt-5 flex items-center gap-3" style={{ fontSize: "0.95rem", fontWeight: 600, color: "#fff" }}>
                  <span className="rounded-full" style={{ width: 8, height: 8, background: "#4E85FF", boxShadow: "0 0 12px #4E85FF" }} />
                  {PRODUCTS.availability}
                </div>
                <button onClick={() => joinWaitlist(p.name)} className="v-link mt-6 self-start">
                  {p.link} <ArrowRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
